import BaseModelAPI from '../BaseModelAPI';

export default class ApprovalInstance extends BaseModelAPI {
	static entity = 'approvalinstance';
	static entityName = 'approvalinstance';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.approvalTag = '';
			this.approvalConfigurationId = '';
			this.approvalConfiguration = {};
			this.approvalConfigurationInstanceId = '';
			this.approvalConfigurationInstance = {};
			this.approvalTypeId = '';
			this.approvalType = {};
			this.currentApproverSequence = 0;
			this.approvalStateId = '';
			this.approvalState = {};
			this.documentId = '';
			this.status = '';
			this.originatorId = '';
			this.createdBy = '';
			this.originator = {};
			this.approvalStructureId = '';
			this.approvalStructure = {};
			this.approversState = []
			this.isFromUpload = false;
			this.createdDate = '';
			this.updatedDate = '';
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}